import type { IConfirmDialogOptions, IDialogOptions, IPromptDialogOptions } from "~/types/dialog";
import type { IToast } from "~/types/toast";

// #region Printing Events
export const printingOpen = () => {
  EventBus.$emit("PRINTING_OPEN");
};
export const printingClose = () => {
  EventBus.$emit("PRINTING_CLOSE");
};
export const printingAddLabel = (
  packageNumber?: string,
  selectAll?: boolean,
  select?: string[] | number[],
  filter?: { [key: string]: string | number | boolean }
) => {
  EventBus.$emit("PRINTING_ADD_LABEL", packageNumber, selectAll, select || [], filter || {});
};
export const printingAddTransfer = (transferId?: number) => {
  EventBus.$emit("PRINTING_ADD_TRANSFER", transferId);
};
export const printingAddConsignment = (consignmentNumber?: string) => {
  EventBus.$emit("PRINTING_ADD_CONSIGNMENT", consignmentNumber);
};
// #endregion

// #region Invite Users
export const inviteUsersOpen = () => {
  EventBus.$emit("INVITEUSERS_OPEN");
};
export const inviteUsersClose = () => {
  EventBus.$emit("INVITEUSERS_CLOSE");
};
export const inviteUsersToggle = () => {
  EventBus.$emit("INVITEUSERS_TOGGLE");
};
// #endregion

// #region Create Tickets
export const createTicketOpen = () => {
  EventBus.$emit("CREATETICKET_OPEN");
};
export const createTicketClose = () => {
  EventBus.$emit("CREATETICKET_CLOSE");
};
export const createTicketCreated = () => {
  EventBus.$emit("CREATETICKET_CREATED");
};
export const createTicketAdd = (types: object, package_number: string) => {
  EventBus.$emit("CREATETICKET_ADD", types, package_number);
};
// #endregion

// #region Global Loader
export const globalLoaderOpen = (text?: string) => {
  EventBus.$emit("LOADER_OPEN", text);
};
export const globalLoaderClose = (text?: string) => {
  EventBus.$emit("LOADER_CLOSE", text);
};
export const globalLoaderToggle = (text?: string) => {
  EventBus.$emit("LOADER_TOGGLE", text);
};
// #endregion

// #region Toast Messages
export const toastAdd = (message: IToast) => {
  EventBus.$emit("TOAST_ADD", message);
};
export const toastClear = () => {
  EventBus.$emit("TOAST_CLEAR");
};
export const toastRemove = (messageId: string | number) => {
  EventBus.$emit("TOAST_REMOVE", messageId);
};
// #endregion

// #region Dialog
export const dialogAlert = (options: IDialogOptions) => {
  EventBus.$emit("DIALOG_OPEN", "alert", options);
};
export const dialogConfirm = (options: IConfirmDialogOptions) => {
  EventBus.$emit("DIALOG_OPEN", "confirm", options);
};
export const dialogPrompt = (options: IPromptDialogOptions) => {
  EventBus.$emit("DIALOG_OPEN", "prompt", options);
};
export const dialogModal = (options: IDialogOptions) => {
  EventBus.$emit("DIALOG_OPEN", "modal", options);
  return () => {
    EventBus.$emit("DIALOG_CLOSE");
  };
};
// #endregion
